import { useCallback } from 'react';
import { useStores } from '../../../stores';
import { toJS } from 'mobx';
import {
  formatUserAccessRoutes,
  UserAccessConstants,
} from '../../helper-utils/userAccess';
import { getSpecificDeductibleAmount } from '../../helper-utils/specificDeductiblehHelper';
import { getDateFromMonthAndYear } from '../../helper-utils/helper';
import { useNavigate } from 'react-router-dom';

export const useUserAccess = () => {
  const {
    userDetailsStore,
    loginPageStore,
    employerGroupStore,
    careNavigatorStore,
  } = useStores();

  const navigate = useNavigate();

  const updateUserAccess = useCallback(
    (egNid: string) => {
      if (userDetailsStore.userAccess) {
        const riskGroups = toJS(userDetailsStore.riskManagementGroups);
        const complianceGroups = toJS(
          userDetailsStore.complianceAssuranceGroups,
        );
        const careNavigationGroups = toJS(
          userDetailsStore.careNavigationGroups,
        );

        const riskRoutes =
          riskGroups?.find((group) => egNid === group.egNid)?.screens || [];
        const complianceRoutes =
          complianceGroups?.find((group) => egNid === group.egNid)?.screens ||
          [];
        const careNavigationRoutes =
          careNavigationGroups?.find((group) => egNid === group.egNid)
            ?.screens || [];

        const {
          userFeatures,
          userAccessRoutes: formatedUserAccessibleRoutes,
        } = formatUserAccessRoutes([
          ...riskRoutes,
          ...complianceRoutes,
          ...careNavigationRoutes,
        ]);

        loginPageStore.addUserAccessRoutes(formatedUserAccessibleRoutes);
        loginPageStore.addUserFeatures(userFeatures);
        loginPageStore.setMemberIdentification(
          userFeatures?.includes(UserAccessConstants.MEMBER_IDENTIFICATION),
        );
      }
    },
    [userDetailsStore, loginPageStore],
  );

  const handleEmployerGroupCardClick = useCallback(
    async (item: any, route: string, startDate?: string, endDate?: string) => {
      employerGroupStore.setEmployerGroupResponseData(item);
      employerGroupStore.setIsIndividualGroup(true);

      getSpecificDeductibleAmount(
        getDateFromMonthAndYear(item?.start_month, item?.recent_plan_year),
        getDateFromMonthAndYear(item?.end_month, item?.end_year, true),
        item?.eg_nid,
        employerGroupStore,
      );

      if (item.care_navigation_id) {
        careNavigatorStore.setGroupData(
          item.care_navigation_id || '',
          item.employer_group_name[0],
          item.eg_nid[0],
          true,
        );
      }
      const duration = {
        startDate,
        endDate,
      };

      updateUserAccess(item.eg_nid?.[0]);

      navigate(route, { state: duration });
    },
    [employerGroupStore, careNavigatorStore, updateUserAccess],
  );

  return {
    updateUserAccess,
    handleEmployerGroupCardClick,
  };
};
